<template>
<div class="mainWrap">
  <div class="mainHeader">
    <div class="mainLogoWrap">
      <div class="mainLogo"></div>
    </div>
    <div class="mainAddress">
      <div class="flex">
        <p v-if="appFlag" @click='createPopUp("#app.cusLayer")'>{{this.mainAddress}}</p>
        <p v-else-if="groupQrData.isFixedAddress == 'Y'" v-show="groupQrData.orderGroupName">{{groupQrData.orderGroupName}} {{ detailAddress ? detailAddress : '' }}</p>
        <p v-else v-show="addressByLotNum">
          {{addressByLotNum}}
        </p>
        <div v-if="appFlag" class="addressArrow" @click='createPopUp("#app.cusLayer")'></div>
      </div>

      <div class='btnNavi langNavi' v-if="this.isGlobalButtonEnabled()">
        <span
          @click="toggleLangBox"
          class="ico lang"
          :class="{ ko: isKo, en: isEn, cn: isCn}"></span>
        <div class="langBox" style="display: none">
          <span class="ico lang ko" @click="setKorean()"></span>
          <span class="ico lang en" @click="setEnglish()"></span>
          <span class="ico lang ch" @click="setChinese()"></span>
        </div>
      </div>
      <div v-if="appFlag && isUser" class="mainNoti" @click="moveNotify()"></div>
    </div>
  </div>
  <div class="mainContainer">
    <div style="background-color: #FF5522;">
      <div class="mainBg">
        <div class="mainContent">
      <div>
          </div>
          <div class="mainSearch" v-if="appFlag">
            <input type='text'
              :placeholder="$i18n.locale == 'ko' ? '매장명 검색' : $i18n.locale == 'en' ? 'Store name search' : '店铺名称搜索'"
              @click='searchBtn'/>
            <div class="mainSearchIco" @click='searchBtn'></div>
          </div>
          <div class="mainFoodTitle" v-if="appFlag">
            <!-- <p>{{$t(`${'QR.food'}`)}} <span>{{$t(`${'QR.pleaseChoose'}`)}}</span></p> -->
<!--             <p><span>순천 조례동과 서울 명동에서</span> 시작합니다.</p>-->
<!--            <p><span>전남 순천시 조례동부터</span> 시작합니다.</p>-->
            <p><span>경기도 용인특례시에도</span><br/>온누리오더 서비스가 시작됩니다</p>
          </div>
          <div class="main-menu-list" v-show="list.length > 0">
            <div class="main-menu-list-item" v-for="(item,index) in list" :key="index"  @click="moveList(item)">
                <span class="img-box">
                  <img :src="setImg(item.detailCode)" alt="image">
                </span>
                <span class="title-box">{{$i18n.locale == 'ko' ? item.langKrNm : $i18n.locale == 'en' ? item.langEnNm : $i18n.locale == 'cn' ? item.langChNm : item.langKrNm}}</span>
              <!-- <template v-if="appFlag">
              모든페이 마스너 버전 임시수정
                <img class="mainCateImg" :src="setImg(item.foodClassDetailCode)" alt="image">
                <span>{{item.foodClassName}}</span>
              </template> -->
              <!-- <template>
                <img class="mainCateImg" :src="setImg(item.detailCode)" alt="image">
                <span>{{$i18n.locale == 'ko' ? item.langKrNm : $i18n.locale == 'en' ? item.langEnNm : $i18n.locale == 'cn' ? item.langChNm : item.langKrNm}}</span>
              </template> -->
            </div>
          </div>
          <div class="main-banner" @click="goOpenAreaList()">
            <img src="@/assets/img/banner-new-store-main-onnuri-kor.png" alt="" style="width: 100%;">
          </div>
<!--          <div class="draditional" @click="moveList()">-->
<!--            <div class="draditionalLeft">-->
<!--              <div class="draditionalTit">-->
<!--                <p>전통관</p>-->
<!--                <div class="arrow"></div>-->
<!--              </div>-->
<!--              <div class="draditionalTxt">온누리상품권, 전통시장</div>-->
<!--            </div>-->
<!--            <div class="draditionalRight">-->
<!--              <img src="../assets/img/img-draditional-market.png">-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="bottom-banner" v-if="$i18n.locale == 'cn'">
      <img src="@/assets/img/banner-main-web-01-chi.png" style="width: 100%;">
    </div>
    <div class="bottom-banner" v-else-if="$i18n.locale == 'en'">
      <img src="@/assets/img/banner-main-web-01-en.png" style="width: 100%;">
    </div>
    <div class="bottom-banner" v-else>
      <img src="@/assets/img/banner-main-web-01-kor.png" style="width: 100%;">
    </div>
    <AppCompanyInfo :class="{pb65: appFlag }"/>
  </div>
  <AppMainAddress
    :addressList.sync="addressList"
    :homeFlag="homeFlag"
    @addresslist="addresslist"
    @moveGroup="moveGroup"
    @closePopUp="handleClosePopUp"
  />
  <MyLocation />
  <BottomMenu v-if="appFlag"/>
  <SingleBtnDialog
    v-if='showSingleBtnDialogFlag'
    :messageType='singleBtnMsgType'
    :onClickConfirmBtn='onClickConfirmBtn'/>
  <NoticePopup v-if="currentPopup"
    :noticeList="currentPopup"
    :popupIndex="currentPopupIndex"
    :popupTomorrowFlag="popupTomorrowFlags[currentPopupIndex] || false"
    @updatePopupFlag="updatePopupFlag"
    @closePopup="closePopup"
  >
  </NoticePopup>
</div>
</template>
<script>
/* eslint-disable eqeqeq */
import $ from 'jquery'
import service from '@/backend/modnpay_app_api'
import NoticePopup from '@/components/App/NoticePopup.vue'
import BottomMenu from '@/components/App/BottomMenu.vue'
import AppCompanyInfo from '@/components/App/AppCompanyInfo.vue'
import AppMainAddress from '@/components/App/AppMainAddress.vue'
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
import MyLocation from '@/views/MyLocation.vue'
import { OPEN_AREA_STORE_LIST_NAME, FRANCHISE_DETAIL_NAME } from '@/utils/EndPoint'
// TODO : 2025-12-10 명동 포장 관련 임시 , import TakeOutStore from '@/utils/TakeOutStore' 추가로 mixins 부분 삭제
import TakeOutStore from '@/utils/TakeOutStore'
export default {
  name: 'GROUP_QR_PAGE_NAME',
  mixins: [TakeOutStore],
  components: {
    BottomMenu, AppMainAddress, SingleBtnDialog, AppCompanyInfo, NoticePopup, MyLocation
  },
  data () {
    return {
      noticeList: [], // API에서 받아온 공지 목록
      currentPopupIndex: 0, // 현재 표시 중인 팝업의 인덱스
      popupTomorrowFlags: [], // 각 팝업별 '오늘 하루 보지 않기' 체크 상태

      homeFlag: false,
      mainAddress: '',
      list: [], // 그룹QR 카테고리 응답리스트
      addressList: [],
      addressByLotNum: '', // 지번주소
      groupQrData: JSON.parse(sessionStorage.getItem('GroupQrData')),
      showSingleBtnDialogFlag: false,
      singleBtnMsgType: '',
      detailAddress: '',
      time: ''
    }
  },
  computed: {
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    },
    currentPopup () {
      return this.noticeList[this.currentPopupIndex] || null
    }
  },
  beforeCreate () {
    localStorage.removeItem('recentAddress')
  },
  watch: {
    noticeList: {
      handler (newList) {
        this.popupTomorrowFlags = new Array(newList.length).fill(false) // 공지 개수만큼 초기화
      },
      immediate: true // 값이 처음 설정될 때도 handler가 호출됨
    }
  },
  mounted () {
    if (!this.appFlag) {
      if (this.groupQrData.isFixedAddress == 'Y') {
        this.hotelServiceFlag = true
        this.detailAddress = JSON.parse(sessionStorage.getItem('selectAddress')).detailAddress2
      }
      if (this.$route.query.addressByLotNum) {
        this.addressByLotNum = this.$route.query.addressByLotNum
        this.mainAddress = this.$route.query.addressByLotNum
      } else {
        this.addressByLotNum = JSON.parse(sessionStorage.getItem('selectAddress')).jibunAddr
        this.mainAddress = JSON.parse(sessionStorage.getItem('selectAddress')).jibunAddr
      }
    } else {
      this.noticePopupList()
      this.addresslist()
    }
    this.callCategoryList()
    this.selectTakeOutList()
  },
  updated () {
    sessionStorage.getItem('langType')
      ? this.$i18n.locale = sessionStorage.getItem('langType')
      : this.$i18n.locale = this.$store.getters.langType
  },
  methods: {
    async noticePopupList () {
      const req = {
        displayType: '13' // 관리자에서 관리하는 온누리오더 앱 구분 값
      }
      const { data } = await service.noticePopupList(req)
      if (data.resultCode === 0) {
        // 쿠키에서 'popup_'으로 저장된 공지 seq 값 추출
        const cookies = document.cookie.split('; ').map(cookie => cookie.split('=')[0])
        const popupSeqs = cookies
          .filter(cookie => cookie.startsWith('popup_'))
          .map(cookie => Number(cookie.replace('popup_', '')))

        // 쿠키에 없는 공지만 리스트에 저장
        this.noticeList = data.noticeList.filter(notice => !popupSeqs.includes(notice.noticeSeq))

        if (this.noticeList.length > 0) {
          document.querySelector('body').style.overflow = 'hidden'
        }
        // 첫 번째 팝업부터 표시
        this.currentPopupIndex = 0
      }
    },
    closePopup () {
      const currentNotice = this.noticeList[this.currentPopupIndex]

      // '오늘 하루 보지 않기' 체크 여부 확인
      if (this.popupTomorrowFlags[this.currentPopupIndex]) {
        const expireDate = new Date()
        expireDate.setHours(23, 59, 59, 999) // 오늘 밤 12시까지 유효
        document.cookie = `popup_${currentNotice.noticeSeq}=true; expires=${expireDate.toUTCString()}; path=/`
        this.saveCookie(`popup_${currentNotice.noticeSeq}=true; expires=${expireDate.toUTCString()};`)
      }

      // 다음 팝업으로 이동
      if (this.currentPopupIndex < this.noticeList.length - 1) {
        this.currentPopupIndex++
      } else {
        document.querySelector('body').removeAttribute('style')
        this.currentPopupIndex = -1 // 모든 팝업이 닫히면 숨김
      }
    },
    updatePopupFlag (index, value) {
      this.$set(this.popupTomorrowFlags, index, value) // Vue의 반응성을 유지하며 배열 값 업데이트
    },

    toggleLangBox () {
      $('.langNavi .langBox').fadeToggle(200)
    },
    setKorean () {
      this.$i18n.locale = 'ko'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.toggleLangBox()
    },
    setEnglish () {
      this.$i18n.locale = 'en'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.toggleLangBox()
    },
    setChinese () {
      this.$i18n.locale = 'cn'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = 'MODNPAY智慧点餐'
      this.toggleLangBox()
    },

    async callCategoryList () { // 카테고리 및 주소 조회
      const req = {}
      if (!this.appFlag) {
        req.orderGroupSeq = this.groupQrData.orderGroupSeq
        req.orderGroupFixedCode = this.groupQrData.orderGroupFixedCode
      }

      const { data } = this.appFlag ? await service.foodClassList(req) : await service.categoryList(req)

      if (data.resultCode == '0' || data.resultCode == '0000000') { // 성공
        this.list = data.list
        if (this.appFlag) {
          this.addressByLotNum = data.addressByLotNum
          this.mainAddress = data.mainAddress
        }
        this.time = Date.now()
      }
    },
    async addresslist () { // 주소 목록 조회 메서드
      const req = {}
      const { data } = await service.addresslist(req)
      if (data.resultCode == '0') { // 성공 시
        this.addressList = data.addressList // 주소 리스트 설정
        this.homeFlag = data.addressList.map(item => item.addressType).includes(0) // 집 주소 플래그 설정

        if (this.addressList.length == 0) {
          try {
            await this.appMoveFirstAddress()
          } catch (err) {
            if (err.name !== 'NavigationDuplicated') {
              console.log(err.name)
              throw err
            }
          }
        }
        const mainAddress = data.addressList.filter(item => item.mainFlag == '1')
        sessionStorage.setItem('selectAddress', JSON.stringify(mainAddress[0]))
        // this.loading = false
      }
    },
    moveList (item) {
      if (item) {
        // sessionStorage.setItem('tradition', false)
        sessionStorage.setItem('categoryCode', item.detailCode)
        sessionStorage.setItem('time', this.time)
      } else {
        sessionStorage.setItem('tradition', true)
        sessionStorage.setItem('categoryCode', '')
        sessionStorage.setItem('time', this.time)
      }
      sessionStorage.setItem('addressByLotNum', this.addressByLotNum)
      this.$router.push({ name: 'AppStoreList' })
    },
    moveNotify () {
      this.$router.push({ name: 'AppNotify' })
    },
    moveGroup (addressEmdNm) {
      this.removePopUp()
      if (this.groupQrData.roomServiceUseYn == 'Y' || this.groupQrData.taxiCallUseYn == 'Y') {
        this.$router.push({ name: 'HotelService' })
      } else {
        this.$router.push({
          name: 'AppMain',
          query: { addressByLotNum: this.appFlag ? this.addressByLotNum : addressEmdNm }
        })
      }
    },
    searchBtn () { // 검색어 조건 검사
      this.$router.push({ name: 'SEARCH', query: { searchType: 1 } })
    },
    handleClosePopUp () { // 팝업 닫기 이벤트 핸들러
      this.callCategoryList()
      if (this.appFlag) {
        this.addresslist()
      }
    },
    onClickConfirmBtn () {
      this.showSingleBtnDialogFlag = false
    },
    setImg (code) {
      switch (code) {
        case '010100': return require('../assets/img/ic_food_korea.png')// 한식
        case '040100': return require('../assets/img/ic_food_china.png')// 중식/일식
        case '090100': return require('../assets/img/ic_food_western.png')// 양식
        case '160100': return require('../assets/img/ic_food_franchise.png')// 프렌차이즈
        case '020100': return require('../assets/img/ic_food_chicken.png')// 치킨
        case '030100': return require('../assets/img/ic_food_ricecake.png')// 분식
        case '130100': return require('../assets/img/ic_food_night.png')// 야식
        case '110100': return require('../assets/img/ic_food_cake.png')// 카페/디저트
        case '170100': return require('../assets/img/ic_life_mart.png')// 마트
        case '180100': return require('../assets/img/ic_life_flower.png')// 꽃
        case '190100': return require('../assets/img/ic_life_market.png')// 전통시장
        case '200100': return require('../assets/img/ic_life_pet.png')// 펫
      }
    },
    goMap () {
      this.$router.push({ name: FRANCHISE_DETAIL_NAME })
    },
    // TODO : 2025-12-10 명동 포장 관련 임시 , selectTakeOutList 메서드 추가
    async selectTakeOutList () {
      const req = {}
      const { data } = await service.takeOutList(req)
      if (data.resultCode === 0) { // 성공 시
        let takeOutStoreList = []
        if (data && data.takeOutList) {
          takeOutStoreList = Array.isArray(data.takeOutList) ? data.takeOutList : []
        }
        this.setTakeOutStoreList(takeOutStoreList)
      }
    },
    goOpenAreaList () {
      this.$router.push({ name: OPEN_AREA_STORE_LIST_NAME })
    }
  }
}
</script>
<!-- 2026-01-09 -->
<style lang="scss" scoped>
.pb65 {
  padding-bottom: 65px !important;
}
.button-group__first-line-image {
  flex-wrap: wrap;
}
#footer {
  background-color: #fff;
  padding-bottom: 0;
  margin-bottom: 53px;
}
.main-banner {
  margin-top: 4px;
  img {
    width: 100%;
  }
}

// 2026-03-23
.main {
  &-menu-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 16px;
    column-gap: 8px;
    margin: 24px 0;
    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      .img-box {
        padding: 0 8px;
        img {
          width: 100%;
        }
      }
      .title-box {
        font-size: 14px;
        line-height: 1.3; //2026-03-31
        text-align: center;
        word-break: break-word; /* 영문 연속 단어 강제 줄바꿈 */
      }
    }
  }
}

.mainFoodTitle {
  line-height: 1.4;
}
</style>
